import http from 'hub-http/clients/apiClient';
export const fetchCallSid = engagementId => {
  return http.get(`/engagements/v2/engagements/${engagementId}?properties=hs_call_external_id`).then(engagement => {
    return engagement && engagement.properties && engagement.properties.hs_call_external_id && engagement.properties.hs_call_external_id.value;
  });
};